import {
  Card,
  CardContent,
  CardMedia,
  styled,
} from "@mui/material";
import { Link } from "react-router-dom";
import CommonLabel from "./label";


const StyeledCard = styled(Card)(({ theme }) => ({
  background: "#f857a659",
  borderRadius: "16px",
  boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
  backdropFilter: "blur(5px)",
  webkitBackdropFilter: "blur(5px)",
  border: `1px solid #FF5858`,
  width: "150px",
  maxWidth: "150px",
  padding: "10px",
  minHeight: "14rem",
  // height: '200px',
  // borderRadius: '16px',
  // background: theme.palette.customGradient.primaryGradient,

  // backdropFilter: 'blur(5px)',
  // webkitBackdropFilter: 'blur(5px)',
  // border: `1px solid ${theme.palette.customGradient.primaryGradient}`
}));
const BrandCard = (props) => {
  const destination = props?.cardUrl?.includes("/")
    ? `/${props.cardUrl.replace(/^\/+/, "")}`
    : `/brand/${encodeURIComponent(props?.cardUrl || "")}`;

  const changePage = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "brandpage_click",
      brand_name: props?.cardText,
    });
  };

  return (
    <>
      <Link
        to={destination}
        onClick={changePage}
        style={{ textDecoration: "none" }}
      >
        <StyeledCard>
          <CardMedia
            component={"img"}
            height={145}
            image={props?.cardImage}
            alt={props?.cardText}
            sx={{ objectFit: "contain" }}
          />
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "row",
              padding: "5px",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <CommonLabel
              variant="h6"
              fontSize={"1rem"}
              sx={{ textTransform: "capitalize" }}
            >
              {props?.cardText > 20
                ? props?.cardText.slice(0, 20)
                : props?.cardText}{" "}
            </CommonLabel>
          </CardContent>
        </StyeledCard>
      </Link>
    </>
  );
};

export default BrandCard;
